import React from "react";
import Hero from "../components/Hero";
import { useIntl } from "react-intl";
import LinkBox from "../components/LinkBox";

export type PISecureElectronicsProps = {};

const PISecureElectronics: React.FC<PISecureElectronicsProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={"/img/electronics-rs.jpg"}
        heading={intl.formatMessage({
          id: "public_info_3",
        })}
      />
      <div className="content">
        <div className="w-full flex flex-col md:flex-row flex-wrap">
          <div className="w-full md:w-1/2 p-2">
            <LinkBox
              target="_blank"
              href="/pdf/secure_elect/MCB-SMR-032 Uso de la contrasena y marca de conformidad.docx"
              label={intl.formatMessage({
                id: "pw-usage",
              })}
            />
          </div>
          <div className="w-full md:w-1/2 p-2">
            <LinkBox
              target="_blank"
              href="/pdf/secure_elect/MCB-CCP-002 Contrato general de prestacion de servicios de certificacion.docx"
              label={intl.formatMessage({
                id: "service-contract",
              })}
            />
          </div>
          <div className="w-full md:w-1/2 p-2">
            <LinkBox
              target="_blank"
              href="/pdf/secure_elect/MCB-DOS-064 Solicitud de servicios equipos electricos y electronicos.docx"
              label={intl.formatMessage({
                id: "elect-application",
              })}
            />
          </div>
          <div className="w-full md:w-1/2 p-2">
            <LinkBox
              target="_blank"
              href="/pdf/secure_elect/MCB-DOS-065 Requisitos de certificacion equipos electricos y electronicos.pdf"
              label={intl.formatMessage({
                id: "elect-cert-req",
              })}
            />
          </div>
          <div className="w-full md:w-1/2 p-2">
            <LinkBox
              target="_blank"
              href="/pdf/secure_elect/MCB-DOS-108 Lista de precios Equipos electricos y electronicos.pdf"
              label={intl.formatMessage({
                id: "price-list",
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PISecureElectronics;
